import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';

export function getIsCopilotUIDisabled(mailboxInfo: MailboxInfo): boolean {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return !!getStore().copilotGeneralPreferencesMap.get(accountKey)?.isCopilotUIDisabled;
}
